import { render, staticRenderFns } from "./LicenseView.vue?vue&type=template&id=7d1f2b3a&scoped=true"
import script from "./LicenseView.ts?vue&type=script&lang=ts&external"
export * from "./LicenseView.ts?vue&type=script&lang=ts&external"
import style0 from "./LicenseView.vue?vue&type=style&index=0&id=7d1f2b3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1f2b3a",
  null
  
)

export default component.exports